import React from 'react';

const Select = ({disabled, selectedOption,id,initialValue,name, defaultSelect, label,required, options, onChange, width, selectdivstyl }) => {
  const handleOptionSelect = (event) => {
    
    const optionValue = event.target.value;
    const optionKey = event.target.options[event.target.selectedIndex].getAttribute('data-key');
    onChange(event, optionValue, optionKey);
  };

  return (
  <div className={selectdivstyl}>
  <label htmlFor={id} className="select-label">{label}<span className='text-danger'>{required}</span></label>
    <select disabled={disabled} id={id} value={selectedOption} onChange={handleOptionSelect} className="custom-select" style={{width:width}} name={name}>
      <option value={initialValue} selected={defaultSelect}>{initialValue}</option>
      {options?.map((option, index) =>{ 
        if(typeof option.label === 'string'){
          return(
            <option key={index} value={option.label} data-key={option.value}>
              {option.label}
            </option>
          )
        }
        if(typeof option.label === 'object'){
          return(
            <option key={index} value={option.label.event_classification_name} data-key={option.value}>
              {option.label.event_classification_label}
            </option>
          )
        }
      })}
    </select>
  </div>
  );
};
export default Select;
